import type { CellValue } from "../../../types/types";

interface CellDateTimeProps {
    cellValue: CellValue;
}

export const CellDateTimeValue = ({ cellValue }: CellDateTimeProps) => {
    function formatDateTime(input: string): string {
        const date = new Date(input);
        const pad = (n: number) => n.toString().padStart(2, "0");
        const day = pad(date.getDate());
        const month = pad(date.getMonth() + 1); // Months are zero-indexed
        const year = date.getFullYear();
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());
        const seconds = pad(date.getSeconds());

        return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
    }

    const dateTime = typeof cellValue === "string" ? formatDateTime(cellValue) : "";

    return <span>{dateTime}</span>;
};
